
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import '../assets/css/blog.css';
import API_BASE_URL from "../../helper";

function ReadBlog() {

  const { id } = useParams();

  const [blog, setBlog] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/admin/blog/get/${id}`)
      .then(res => res.json())
      .then(data => setBlog(data))
      .catch(err => console.error("Blog fetch failed", err));
  }, [id]);

  if (!blog) {
    return <p className="text-center mt-5">Loading Blog...</p>;
  }

  return (
    <div>
      <div 
        id="blog-hero-section" 
        className="d-flex justify-content-center flex-column"
        style={{
          background: `url(${API_BASE_URL}/assets/Images/${blog.image}) center/cover no-repeat`,
        }}
      >
        <div className="container">
          <p className="hero-subheading">{blog.heading}</p>
        </div>
      </div>

      <section id='readBlogSection' className='mt-5'>
        <div className='container'>
          <h2 className='blogHeading'>{blog.subHeading}</h2>
          <p>{blog.description}</p>
          <h4>{blog.title}</h4>
        </div>
      </section>
    </div>
  );
}

export default ReadBlog;
